import { Container, Center, Loader, Stack, Text } from '@mantine/core';

interface LoadingFallbackProps {
  message?: string;
}

export function LoadingFallback({ message = 'Loading...' }: LoadingFallbackProps) {
  return (
    <Container size="xl" py="xl">
      <Center mih="60vh">
        <Stack align="center" gap="md">
          <Loader size="lg" />
          <Text c="dimmed">{message}</Text>
        </Stack>
      </Center>
    </Container>
  );
}
